module.exports = __webpack_public_path__ + "img/kw.cc4df293.svg";